function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Heading from '@/components/Heading';
import useChannelStore from '@/stores/ChannelStore';
import StatGraphs from '@/components/dashboard/StatGraphs';
import { Flex, Grid, GridItem } from '@chakra-ui/react';
import TopChatter from '../dashboard/TopChatter';
import TopCommand from '@/components/dashboard/TopCommand';
import StatusMenu from '../dashboard/StatusMenu';
import { getChatterStats, getCommandStats, getStats } from '@/actions/StatActions';
import DashboardLayout from '@/components/layouts/DashboardLayout';
import { useIntl } from 'react-intl';
import useIntlMemo from '@/hooks/useIntlMemo';
import { Helmet } from 'react-helmet';
export default function Dashboard() {
    var intl = useIntl();
    var channel = useChannelStore(function(state) {
        return state.channel;
    });
    var _React_useState = _sliced_to_array(React.useState(null), 2), graphStats = _React_useState[0], setGraphStats = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(true), 2), graphStatsLoading = _React_useState1[0], setGraphStatsLoading = _React_useState1[1];
    var _React_useState2 = _sliced_to_array(React.useState(null), 2), chatters = _React_useState2[0], setChatters = _React_useState2[1];
    var _React_useState3 = _sliced_to_array(React.useState(true), 2), chattersLoading = _React_useState3[0], setChattersLoading = _React_useState3[1];
    var _React_useState4 = _sliced_to_array(React.useState(null), 2), commands = _React_useState4[0], setCommands = _React_useState4[1];
    var _React_useState5 = _sliced_to_array(React.useState(true), 2), commandsLoading = _React_useState5[0], setCommandsLoading = _React_useState5[1];
    React.useEffect(function() {
        if (channel == null) {
            return;
        }
        setGraphStatsLoading(true);
        setChattersLoading(true);
        setCommandsLoading(true);
        getStats(channel._id).then(function(stats) {
            return setGraphStats(stats);
        }).finally(function() {
            return setGraphStatsLoading(false);
        });
        getChatterStats(channel._id).then(function(chatters) {
            return setChatters(chatters);
        }).finally(function() {
            return setChattersLoading(false);
        });
        getCommandStats(channel._id).then(function(commands) {
            return setCommands(commands);
        }).finally(function() {
            return setCommandsLoading(false);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        channel === null || channel === void 0 ? void 0 : channel._id
    ]);
    var greeting = useIntlMemo(function(intl) {
        var date = new Date();
        var hour = date.getHours();
        if (channel == null) {
            return intl.formatMessage({
                id: "Q+U0TW",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Welcome!"
                    }
                ]
            });
        }
        if (hour < 12) {
            return intl.formatMessage({
                id: "P+3q7z",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Good Morning, "
                    },
                    {
                        type: 1,
                        value: "username"
                    }
                ]
            }, {
                username: channel === null || channel === void 0 ? void 0 : channel.displayName
            });
        } else if (hour < 18) {
            return intl.formatMessage({
                id: "fsmkbC",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Good Afternoon, "
                    },
                    {
                        type: 1,
                        value: "username"
                    }
                ]
            }, {
                username: channel === null || channel === void 0 ? void 0 : channel.displayName
            });
        } else {
            return intl.formatMessage({
                id: "SL8mDe",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Good Evening, "
                    },
                    {
                        type: 1,
                        value: "username"
                    }
                ]
            }, {
                username: channel === null || channel === void 0 ? void 0 : channel.displayName
            });
        }
    }, [
        channel
    ]);
    if (channel == null) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(DashboardLayout, {
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                title: intl.formatMessage({
                    id: "hzSNj4",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Dashboard"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(Flex, {
                gap: 6,
                justifyContent: "space-between",
                flexDirection: {
                    base: 'column',
                    md: 'row'
                },
                alignItems: {
                    base: 'flex-start',
                    md: 'flex-end'
                },
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        subHeading: intl.formatMessage({
                            id: "iIJOqD",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Here's a quick 7-day overview of your channel."
                                }
                            ]
                        }),
                        children: greeting
                    }),
                    /*#__PURE__*/ _jsx(StatusMenu, {
                        size: {
                            base: 'md',
                            md: 'sm'
                        },
                        channel: channel,
                        width: {
                            base: '100%',
                            md: 'auto'
                        },
                        textAlign: "left"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Grid, {
                templateColumns: {
                    base: '1fr',
                    md: 'repeat(2, 1fr)'
                },
                templateRows: "repeat(1, 1fr)",
                gap: 6,
                children: [
                    /*#__PURE__*/ _jsx(GridItem, {
                        colSpan: {
                            base: 1,
                            md: 2
                        },
                        rowSpan: 1,
                        children: /*#__PURE__*/ _jsx(StatGraphs, {
                            stats: graphStats,
                            isLoading: graphStatsLoading
                        })
                    }),
                    /*#__PURE__*/ _jsx(GridItem, {
                        colSpan: 1,
                        rowSpan: 1,
                        children: /*#__PURE__*/ _jsx(TopCommand, {
                            commandStats: commands,
                            isLoading: commandsLoading
                        })
                    }),
                    /*#__PURE__*/ _jsx(GridItem, {
                        colSpan: 1,
                        rowSpan: 1,
                        children: /*#__PURE__*/ _jsx(TopChatter, {
                            chatterStats: chatters,
                            isLoading: chattersLoading
                        })
                    })
                ]
            })
        ]
    });
}
